import * as THREE from 'three';
import { OrbitControls } from 'three/examples/jsm/controls/OrbitControls.js';

import starTexture from '../textures/2k_stars_milky_way.jpg';
import sunTexture from '../textures/2k_sun.jpg';
import mercuryTexture from '../textures/2k_mercury.jpg';
import venusTexture from '../textures/2k_venus_atmosphere.jpg';
import marsTexture from '../textures/2k_mars.jpg';
import earthTexture from '../textures/RS3_EarthC.jpg';
import jupiterTexture from '../textures/2k_jupiter.jpg';
import saturnTexture from '../textures/2k_saturn.jpg';
import saturnRingTexture from '../textures/2k_saturn_ring_alpha.png';
import uranusTexture from '../textures/2k_uranus.jpg';
import neptuneTexture from '../textures/2k_neptune.jpg';
import plutoTexture from '../textures/th.jpeg';
import moonTexture from '../textures/2k_moon.jpg';
import asteroidTexture from '../textures/2k_moon.jpg';

const renderer = new THREE.WebGLRenderer();

renderer.setSize(window.innerWidth, window.innerHeight);

document.body.appendChild(renderer.domElement);

const scene = new THREE.Scene();

const camera = new THREE.PerspectiveCamera(65, window.innerWidth / window.innerHeight, 0.1, 1000);

const orbit = new OrbitControls(camera, renderer.domElement);
orbit.update();

const ambientLight = new THREE.AmbientLight(0x333333);
scene.add(ambientLight);

const cubeTextureLoad = new THREE.CubeTextureLoader();
scene.background = cubeTextureLoad.load([uranusTexture]);

const textureLoader = new THREE.TextureLoader();

camera.position.z = 300;

//earth
const earthGeo = new THREE.SphereGeometry(20, 30, 30);
const earthMat = new THREE.MeshBasicMaterial({
    map: textureLoader.load(earthTexture)
});
const earth = new THREE.Mesh(earthGeo, earthMat);
scene.add(earth);

//moon
const moonGeo = new THREE.SphereGeometry(4.6, 16, 16);
const moonMat = new THREE.MeshBasicMaterial({
    map: textureLoader.load(moonTexture)
});
const moon = new THREE.Mesh(moonGeo, moonMat);
//scene.add
const moonObj = new THREE.Object3D();
moonObj.add(moon);
scene.add(moonObj);
moon.position.x = 38;
moon.position.y = 20;

//asteroid
const asteroidGeo = new THREE.SphereGeometry(1, 5, 7);
const asteroidMat = new THREE.MeshBasicMaterial({
    map: textureLoader.load(asteroidTexture)
});
const asteroid = new THREE.Mesh(asteroidGeo, asteroidMat);
scene.add(asteroid);
asteroid.position.x = 180;

// Meteor trails (simple line representing meteors)
const meteorGeometry = new THREE.CylinderGeometry(1, 0.001, 25, 8);
const meteorMaterial = new THREE.MeshBasicMaterial({ color: 0xfffff, transparent: true, opacity: 0.5});
const meteor = new THREE.Mesh(meteorGeometry, meteorMaterial);
scene.add(meteor);
meteor.position.z = -11;
meteor.position.y = -4.7;
meteor.position.x = 180;
meteor.rotateX(20);

//asteroid1
const asteroidGeo1 = new THREE.SphereGeometry(1, 1, 7);
const asteroidMat1 = new THREE.MeshBasicMaterial({
    map: textureLoader.load(asteroidTexture)
});
const asteroid1 = new THREE.Mesh(asteroidGeo1, asteroidMat1);
scene.add(asteroid1);
asteroid1.position.x = -180;

// Meteor trails (simple line representing meteors)
const meteorGeometry1 = new THREE.CylinderGeometry(1, 0.001, 25, 8);
const meteorMaterial1 = new THREE.MeshBasicMaterial({ color: 0xfffff, transparent: true, opacity: 0.5});
const meteor1 = new THREE.Mesh(meteorGeometry1, meteorMaterial1);
scene.add(meteor1);
meteor1.position.z = 10;
meteor1.position.y = 4.5;
meteor1.position.x = -187;
meteor1.rotateX(20);
meteor1.rotateZ(10);
//asteroid2
const asteroidGeo2 = new THREE.SphereGeometry(1, 13, 7);
const asteroidMat2 = new THREE.MeshBasicMaterial({
    map: textureLoader.load(asteroidTexture)
});
const asteroid2 = new THREE.Mesh(asteroidGeo2, asteroidMat2);
scene.add(asteroid2);
asteroid2.position.z = -180;

// Meteor trails (simple line representing meteors)
const meteorGeometry2 = new THREE.CylinderGeometry(1, 0.001, 25, 8);
const meteorMaterial2 = new THREE.MeshBasicMaterial({ color: 0xfffff, transparent: true, opacity: 0.5});
const meteor2 = new THREE.Mesh(meteorGeometry2, meteorMaterial2);
scene.add(meteor2);
meteor2.position.y = -5.5;
meteor2.position.z = -191;
meteor2.rotateX(20);

function animate() {
    //self rotation
    earth.rotateY(0.004);  
    moon.rotateY(0.004);

    //rotate on body
    moonObj.rotateY(0.03);

    //label
    //labelRender.render(scene, camera);

    renderer.render(scene, camera);
}

renderer.setAnimationLoop(animate);

window.addEventListener('resize', function() {
    camera.aspect = window.innerWidth / window.innerHeight;
    camera.updateProjectionMatrix();
    renderer.setSize(window.innerWidth, window.innerHeight);
});

//remove


document.getElementById('dateInput').addEventListener('click', function(){
    //
    asteroid.position.y = -1;
    asteroid.position.x = 170
    //meteor
    meteor.position.z = -11;
    meteor.position.y = -6;
    meteor.position.x = 170;
    //asteroid1
    asteroid1.position.z = 10;
    //meteor1
    meteor1.position.z = 20;
    meteor1.position.y = 4.5;
    meteor1.position.x = -187;
    //asteroid2
    asteroid2.position.x = 80;
    //meteor2
    meteor2.position.x = 80;
});